import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CallupHead } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getHotEventsData } from '../../../services/api';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import { QQShare } from 'ThreeTerminal_mobile';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

const limitWords = (str, len) => {
    const max = len * 2;
    let num = 0;
    const strArr = str.split('');
    const result = [];

    while (strArr.length && num < max) {
        const word = strArr.shift();

        result.push(word);
        num += word.charCodeAt(0) > 127 ? 2 : 1;
    }

    return result.join('');
};

const isBrowser = typeof window !== 'undefined';

const createTitleDispatch = child => {
    const { type, base62Id, url } = child;

    switch (type) {
        case 'hotEvent':
            return {
                type: 'customPage',
                url: `https://nine.ifeng.com/hotSpotDetailListV2?eventName=${base62Id}&docid=&groupid=&type=customPage`,
            };
        case 'web':
            return { type: 'web', url };
        case 'article':
            return { type: 'doc', url: base62Id };
        case 'video':
            return { type: 'phvideo', url: base62Id };
        case 'slide':
            return { type: 'slide', url: base62Id };
        case 'short':
            return { type: 'short', url: base62Id };
        default:
            return { type, url: base62Id };
    }
};

const createContentDispatch = child => {
    const { type, base62Id, url } = child;

    switch (type) {
        case 'web':
            return { type: 'web', url };
        case 'article':
            return { type: 'doc', url: base62Id };
        case 'video':
            return { type: 'phvideo', url: base62Id };
        case 'slide':
            return { type: 'slide', url: base62Id };
        case 'short':
            return { type: 'short', url: base62Id };
        default:
            return { type, url: base62Id };
    }
};

// 信息流
const NewsFlow = errorBoundary(({ list, loadMore, isClient }) => {
    const newsFlowBtm = useRef(null);
    const intersectionObserver = isBrowser
        ? new IntersectionObserver(entries => {
              if (entries[0].intersectionRatio <= 0) return;
              loadMore();
          })
        : null;

    useEffect(() => {
        if (!intersectionObserver) return;
        intersectionObserver.observe(newsFlowBtm.current);

        return () => intersectionObserver.disconnect();
    }, []);

    const ArticleContent = ({ child }) => {
        const { url, title, thumbnail, catename } = child;
        const content = (
            <div className={styles.content}>
                <div className={`${styles.left} ${!thumbnail ? styles.left_long : null}`}>
                    <div>{title}</div>
                    {/* <div>
                        <span>{catename}</span>
                    </div> */}
                </div>
                {thumbnail ? <img src={thumbnail} alt="" /> : null}
            </div>
        );

        const contentDispatch = createContentDispatch(child);

        if (isClient) {
            return (
                <div
                    onClick={() => {
                        Grounds.dispatch(contentDispatch.type, contentDispatch.url);
                    }}>
                    {content}
                </div>
            );
        } else {
            return <a href={url}>{content}</a>;
        }
    };

    ArticleContent.propTypes = {
        child: PropTypes.object,
    };

    return (
        <div className={styles.newsflow}>
            <div>
                {list.slice(0, 30).map(item => {
                    const { base62Id, url, title, child } = item;
                    const titleDispatch = createTitleDispatch(item);

                    return (
                        <div key={base62Id}>
                            <a
                                href={url}
                                onClick={e => {
                                    if (isClient) {
                                        e.preventDefault();

                                        return Grounds.dispatch(titleDispatch.type, titleDispatch.url);
                                    }
                                }}>
                                <div className={`${styles.main_title} ${styles.main_title_border_fix}`}>
                                    <img src={require('../assets/event.png')} alt="" />
                                    <div>{limitWords(title, 14)}</div>
                                    <img src={require('../assets/arr_title.png')} alt="" />
                                </div>
                            </a>
                            <ArticleContent child={child} />
                        </div>
                    );
                })}
            </div>
            <div style={{ padding: 0 }} ref={ele => (newsFlowBtm.current = ele)} />
            <div className={styles.bottom}>
                <img src={require('../assets/bottom.png')} alt="" />
            </div>
        </div>
    );
});

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props) {
        super(props);
        const { list } = props.content;

        this.state = {
            list: list.content,
            page: list.page,
            isEnd: list.isEnd,
        };
    }

    loadMore = async () => {
        const { content } = this.props;
        const { dynamicId } = content.list;
        const { page, isEnd, list } = this.state;

        if (isEnd) return;

        const res = await getHotEventsData(dynamicId, page);
        const { code, data } = res;

        if (code !== 0) return;

        const { list: newList, toIndex, total } = data;

        this.setState({
            page: page + 1,
            list: [...list, ...newList],
            isEnd: toIndex >= total,
        });
    };

    render() {
        const { content } = this.props;
        const { isClient, isVideoShare, shareInfo, listAd } = content;

        // 插入一条广告的最终列表
        const { list } = this.state;
        const finalList = [...list];

        if (listAd) {
            const { adIndex } = listAd;

            if (adIndex >= 0 && adIndex <= list.length) {
                finalList.splice(adIndex, 0, listAd);
            }
        }

        const headerConfig = {
            isVideoShare,
            pageInfo: {
                type: 'web',
                id: 'https://ishare.ifeng.com/hotTechClient',
                kind: 'web',
                url: isBrowser ? location.href : '',
                position: 1,
                downloads: isVideoShare
                    ? {}
                    : {
                          download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                          downloadAd:
                              'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                      },
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                kind: 'topic',
                callupKind: 'share01',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                kind: 'topic',
                callupKind: 'share01',
            },
            hotKeyword: [
                '这条最新发布的内容，80%的网友都在看',
                '热热热！这条精彩内容，你的朋友们都在看',
                '过去24小时发生了这些好玩的事，点击查看',
                '全网最热新闻出炉，这些事儿你都知道吗？',
                '想不到！今天最火爆的新闻居然是……',
                '这条重磅新闻刚刚发布！快来查看',
                '过去的24小时你错过了这些重要新闻……',
                '今天这条消息，90%的人都不知道！',
            ],
        };

        return (
            <div className={styles.container}>
                <div>
                    {isBrowser && !window.grounds ? (
                        <CallupHead
                            content={headerConfig}
                            closeCallback={() => {
                                this.setState({
                                    scrollDirection: 'down',
                                });
                            }}
                        />
                    ) : null}
                </div>
                <div className={styles.hotNewsheader}>
                    <div className={styles.banner}>
                        <img src={require('../assets/banner.png')} alt="" />
                        <img src={require('../assets/banner_text.png')} alt="" />
                    </div>
                </div>
                <NewsFlow list={finalList} loadMore={() => this.loadMore()} isClient={isClient} />
                <Chip id="170201" type="struct" title="分享信息" groupName="分享信息">
                    <div style={{ display: 'none' }}>
                        <div id="ifeng_share_url">{shareInfo.url}</div>
                        <div id="ifeng_share_title">{shareInfo.title}</div>
                        <div id="ifeng_share_thumbnail">{shareInfo.thumbnail}</div>
                        <div id="ifeng_share_description">{shareInfo.desc}</div>
                        <QQShare
                            content={{
                                title: shareInfo.title,
                                img: shareInfo.thumbnail,
                                desc: shareInfo.desc,
                                cb: () => {
                                    console.log('分享成功');
                                },
                            }}
                        />
                    </div>
                </Chip>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
